var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.3458V16.5958H12.425V18.3458H3.5ZM3.5 13.5333V11.7833H17.2958V13.5333H3.5ZM3.5 8.72083V6.97083H17.2958V8.72083H3.5ZM19.0167 22.1375L15.05 18.1708L16.275 16.9167L19.0167 19.6292L24.4125 14.2333L25.6667 15.4875L19.0167 22.1375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAssigned);
export default __webpack_public_path__ + "static/media/my-assigned.a4057e10617d8362015bb4638dc1f957.svg";
export { ForwardRef as ReactComponent };